import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { TabService } from 'src/app/core/services/tab.service';

@Component({
  selector: 'app-gis-map',
  templateUrl: './gis-map.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./gis-map.component.scss'],
})
export class GisMapComponent implements OnInit {
  protected _tabService = inject(TabService);
  protected _translateService = inject(TranslateService);

  async ngOnInit() {
    const label = await firstValueFrom(
      this._translateService.get('MAP.LABEL.GIS_FIELD_ASSET')
    );
    this._tabService.updateActiveTabLabel(label);
  }
}
